import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.other-project .project-card .project-card-info a {
    color: #3A4FFF;
	}
	.featured-project {
		max-width: 960px;
		width: 50%;
		margin: 22px auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		&.empty {
			margin-top: 84px;
			text-align: center;
			h3 {
				margin-top: 8px;
				font-weight: bold;
			}
		}
		a {
			text-decoration: none;
		}
		.featured-project-info {
    		min-width: 460px;
			width: 50%;
		}
		.featured-project-desc {
			white-space: pre-line;
			margin-bottom: 4px;
		}
		.banner {
    		min-width: 460px;
			width: 50%;
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			position: relative;
			margin-bottom: 22px;
			.progress-bar {
				width: 100%;
				position: absolute;
				bottom: -12px;
				left: 0;
				background-color: #b9b9b9;
				height: 12px;
				overflow: hidden;
				.others {
					position: absolute;
					left: 0;
					top: 0;
					height: 12px;
					padding: 0;
					background-color: #f00;
				}
				.mine {
					position: absolute;
					top: 0;
					height: 12px;
					padding: 0;
					background-color: #00f;
				}
			}
		}
	}
	.other-project {
		max-width: 960px;
		width: 80%;
		margin: 22px auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.other-project-wrapper {
    		min-width: 460px;
			width: 50%;
		}
		a {
			text-decoration: none;
		}
		.ant-pagination {
			margin-top: 8px;
		}
		.project-card {
			margin-top: 8px;
    		min-width: 460px;
			min-height: 102px;
			width: 50%;
			position: relative;
			padding-left: 190px;
			padding-bottom: 12px;
			border-bottom: 1px solid #b9b9b9;
			.project-card-banner {
				position: absolute;
				left: 0;
				top: 0;
				width: 170px;
				height: 90px;
				background-position: center;
				background-size: cover;
			}
			.project-card-info {
				h4 {
					font-size: 14px;
					font-weight: bold;
				}
				p {
					margin: 0;
					line-height: 20px;
					height: 20px;
					font-size: 14px;
				}
				a {
					color: #3A4FFF;
					text-decoration: underline;
				}
			}
		}
	}

	@media (max-width: 1200px) {
		.featured-project {
    		width: 100%;
			align-items: unset !important;

			.featured-project-info {
				min-width: auto;
				max-width: 760px;
				width: 100%;
			}
			.banner {
				min-width: auto;
				max-width: 760px;
				width: 100%;
				margin-bottom: 12px;
			}
		}
		.other-project {
			width: 90%;
			margin: 22px auto;
			.project-card {
				margin-top: 8px;
				min-width: auto;
				max-width: 760px;
				width: 100%;
				min-height: 102px;
				position: relative;
				padding-left: 0;
				padding-bottom: 12px;
				border-bottom: 1px solid #b9b9b9;
				.project-card-banner {
					position: static;
					width: 100%;
					height: 35vw;
					margin: auto;
					background-position: center;
					background-size: cover;
				}
			}
			.other-project-wrapper {
				width: 100%;
				min-width: 300px;
			}
		}
	}
	@media (max-width: 280px) {
        .featured-project {
            width: 70%;
        }
        .other-project {
            margin-left: 3rem;
            .project-card {
                width: 80%;
                .project-card-banner {
                    width: 80%;
                }
            }
        }
    }
`;
